import { Map } from 'immutable';
import Actions from 'flow/actions';

const initialFeatureFlagsState = Map({
    webClientFeatureFlags: Map(),
});

// eslint-disable-next-line complexity
export const featureFlagsReducer = (
    state = initialFeatureFlagsState,
    action: any,
) => {
    switch (action ? action.type : null) {
        case Actions.GET_SET_WEB_CLIENT_FEATURE_FLAGS: {
            return state.setIn(['webClientFeatureFlags'], action.featureFlags);
        }
        default:
            return state;
    }
};

export default featureFlagsReducer;
